var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7389 19.1985C32.06 19.4868 32.0889 19.9834 31.8035 20.3077L23.5072 29.7363C23.3596 29.904 23.1481 30 22.9259 30C22.7038 30 22.4922 29.904 22.3446 29.7363L18.1965 25.022C17.9111 24.6977 17.94 24.201 18.2611 23.9128C18.5821 23.6245 19.0737 23.6537 19.3591 23.978L22.9259 28.0316L30.6409 19.2637C30.9263 18.9394 31.4179 18.9102 31.7389 19.1985Z",
    fill: "#B5CDD1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23,
    stroke: "#377A84",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ff293eb413270eb343cd814243dd0e59.svg";
export { ForwardRef as ReactComponent };